/**
 * Recommended products v2 prev/next for Aero slider.
 * Loaded from sections/recommended-products-v2.liquid as type="module".
 */

const SELECTOR = '[data-section-type="recommended-products-v2"]'

function init(root) {
  if (root.dataset.rpInit) return
  root.dataset.rpInit = 'true'

  const sliderElement = root.querySelector('[data-recommended-products-v2-slider]')
  const prevButton = root.querySelector('[data-recommended-products-v2-prev]')
  const nextButton = root.querySelector('[data-recommended-products-v2-next]')
  if (!sliderElement || !prevButton || !nextButton) return

  let attempts = 0
  const slides = () => sliderElement.querySelectorAll('.aero-slider__slide:not([data-aero-slider-clone])')
  const sync = () => {
    const slider = sliderElement.aeroSlider
    if (!slider) {
      prevButton.disabled = true
      nextButton.disabled = true
      return
    }
    const index = slider.currentIndex ?? 0
    const maxIndex = Math.max(0, Math.floor(slides().length - (slider.slidesPerView || 1)))
    prevButton.disabled = index <= 0
    nextButton.disabled = index >= maxIndex
  }
  const poll = () => {
    sync()
    if (sliderElement.aeroSlider || attempts >= 50) return
    attempts += 1
    window.setTimeout(poll, 100)
  }
  prevButton.addEventListener('click', () => sliderElement.aeroSlider && !prevButton.disabled && sliderElement.aeroSlider.prev())
  nextButton.addEventListener('click', () => sliderElement.aeroSlider && !nextButton.disabled && sliderElement.aeroSlider.next())
  sliderElement.addEventListener('aero:slideChange', sync)
  poll()
}

function initAll(scope = document) {
  if (scope.matches?.(SELECTOR)) init(scope)
  scope.querySelectorAll(SELECTOR).forEach(init)
}

initAll()
document.addEventListener('shopify:section:load', (event) => initAll(event.target))
